<template>
  <div class="member-list-menu">
    <button
      class="members-btn p-1"
      :class="{ active }"
      @click="toggleMenu">
      {{ selectedMemberDepartment && selectedMemberDepartment.name }}
    </button>
    <div
      v-if="active"
      class="member-list_wrapper py-2">
      <ul
        ref="memberList"
        class="member-list">
        <router-link
          v-for="member in memberList"
          :key="member.id"
          :ref="isSelectedMember(member) ? 'selectedMember' : null"
          tag="li"
          :to="`/members/${member.id}`"
          class="member-list_item pl-3"
          :class="{ selected: isSelectedMember(member) }">
          <b-avatar
            class="mr-1"
            size="sm" />
          <div class="member-list_item_name text-left text-truncate font-weight-bold">
            {{ member.name }}
          </div>
          <div class="member-list_item_position text-truncate">
            {{ member.position }}
          </div>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedMember: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      active: false,
      memberList: []
    }
  },
  computed: {
    selectedMemberId() {
      return this.selectedMember.id
    },
    selectedMemberDepartment() {
      if (!this.selectedMember) return null
      return this.selectedMember.department
    },
  },
  watch: {
    selectedMemberId() {
      if (this.active) {
        this.scrollToMember()
      }
    },
    active() {
      if (this.active) {
        this.scrollToMember()
      }
    }
  },
  methods: {
    isSelectedMember(member) {
      return this.selectedMemberId === member.id
    },
    toggleMenu() {
      this.active ? this.hideDropdown() : this.showDropdown()
    },
    async showDropdown() {
      await this.fetchMemberList()
      this.active = true
    },
    hideDropdown() {
      this.active = false
      this.memberList = []
    },
    async fetchMemberList() {
      await this.$axios.get(`/users/?department__in=${this.selectedMember.department.id}&ordering=-sort_no`).then((res) => {
        this.memberList = res.data.results
      })
    },
    scrollToMember() {
      this.$nextTick(() => {
        const selectedMemberElement = this.$refs.selectedMember[0].$el
        // padding分を引く
        const scrollPosition = selectedMemberElement.offsetTop - 13
        this.$refs.memberList.scrollTop = scrollPosition
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.member-list-menu {
  position: relative;
}

.members-btn {
  border-radius: 4px;
  line-height: 1;
  padding: 16px;
  font-weight: bold;
  cursor: pointer;

  background-color: $l-blue;
  box-shadow: 1px 2px 6px $grey05;
  border: none;
  font-size: 0.875rem;

  color: #fff;

  width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.active {
    background-color: $blue;
  }
}

.member-list_wrapper {
  position: absolute;
  right: -32px;
  z-index: 1;
  background-color: $white;
  border-radius: 4px;
  box-shadow: 1px 2px 6px $grey05;
}

.member-list {
  max-width: 150px;
  max-height: 190px;
  padding: 5px 5px 5px 0;
  
  overflow-y: scroll;

  &_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    width: 150px;
    padding: 5px 5px 10px 0;

    &_name {
      width: 75px;
      min-width: 70px;
      flex: 2;
      padding-right: 5px;
      font-size: 0.7rem;

    }

    &_position {
      min-width: 35px;
      text-align: center;
      font-size: 0.5rem;
    }

    &.selected::before {
      content: '';
      position: absolute;
      left: 5px;
      width: 0;
      height: 0;
      border-left: 5px solid black;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
    }
  }
}
</style>